//Models
PJQ.models.primeContracts.ChangeOrder = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'primecontractchangeorders',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.primeContract) {
            this.primeContract = model.primeContract;
        }

        this.lineItems = new PJQ.collections.primeContracts.ChangeOrderLineItems(model.lineItems);
        this.attachments = new PJQ.collections.primeContracts.ChangeOrderAttachments(model.attachments);
        this.invoices = new PJQ.collections.invoicing.ReceivableInvoices(model.invoices);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        }

        if (model && model.reviewer) {
            if (model.reviewer instanceof PJQ.models.BaseModel) {
                this.reviewer = model.reviewer;
            } else {
                this.reviewer = new PJQ.models.contacts.Contact(model.reviewer);
            }
        }

        if (model && model.receivedFrom) {
            if (model.receivedFrom instanceof PJQ.models.BaseModel) {
                this.receivedFrom = model.receivedFrom;
            } else {
                this.receivedFrom = new PJQ.models.contacts.Contact(model.receivedFrom);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    syncERP: function (callback) {
        return PJQ.models.primeContracts.PrimeContract.prototype.syncERP.call(this, callback);
    },
    makeERPUrl: function (integration) {
        return PJQ.models.primeContracts.PrimeContract.prototype.makeERPUrl.call(this, integration);
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.primeContracts.ChangeOrderHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.primeContracts.changeOrderStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.primeContracts.changeOrderStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.primeContracts.ChangeOrderAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.ChangeOrderLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.ChangeOrderCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.primeContracts.ChangeOrderSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.primeContracts.ChangeOrderUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.primeContracts.ChangeOrderFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'primecontractchangeorders'
            }
        ]);
    }
});

//Collections
PJQ.collections.primeContracts.ChangeOrders = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrder,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'primecontractchangeorders'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.primeContracts.changeOrderStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (changeOrder) {
                if (bucket.statuses.indexOf(changeOrder.get('statusId')) !== -1) {
                    total += changeOrder.get('amount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.primeContracts.ChangeOrderHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});


PJQ.collections.primeContracts.ChangeOrderAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderCustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'primecontractchangeorders'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'primecontractchangeorders'
            }
        ]);
    }
});